module.exports = __webpack_public_path__ + "static/img/zhaolihua.8ec8c23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor/zhaolihua.jpg
// module id = dQW3
// module chunks = 1